import React, { useEffect, useState } from "react";
import { useSelector, useDispatch } from "react-redux";

import { Controller, useForm } from "react-hook-form";

import moment from "moment";
import MomentUtils from "@date-io/moment";

import {
	DatePicker,
	MuiPickersUtilsProvider,
} from "@material-ui/pickers";

import TextField from "@material-ui/core/TextField";
import MenuItem from "@material-ui/core/MenuItem";
import InputLabel from "@material-ui/core/InputLabel";
import Button from "@material-ui/core/Button";
import Styles from "./FormCompletedFilter.module.css";

import "moment/locale/pt";
moment.locale("pt");

const FormCompletedFilter = (props) => {
	const { handleSubmit, setValue, control } = useForm();

	const CoursesSearchData = useSelector((state) => state.MyCoursesData.searchData);

	const resetForm = () => {
		console.log("resetForm");
		setValue("name", "");
		setValue("TrainingType", "");
		setValue("startDate", null);
		setValue("endDate", null);
		// setValue("completionDate", ""); // não existe
		setValue("modalityId", "");
		setValue("enrollmentStatusId", "");
		// setValue("isCertificateAvailable", ""); // não existe
	};

	const onSubmit = (data) => {
		console.log(data);

		const refactorData = {...data, startDate: moment(data.startDate).toISOString(), endDate: moment(data.endDate).toISOString()}		
		console.log("refactorData", refactorData)
		
		props.filterData(refactorData);
	};

	useEffect(() => {
		// console.log("clear date")
		setValue("startDate", null);
		setValue("endDate", null);
	}, [setValue]);

	useEffect(() => {
		console.log("CoursesSearchData", CoursesSearchData);
	}, [CoursesSearchData]);

	return (
		<form
			className={Styles["formCompletedFilter"]}
			onSubmit={handleSubmit(onSubmit)}
		>
			<div className={"col-xs-3"}>
				<InputLabel className={Styles["text-field-label"]}>
					Nome
				</InputLabel>
				<Controller
					name="name"
					control={control}
					defaultValue=""
					rules={{ required: { value: false } }}
					render={({ field: { onChange, name, value } }) => (
						<TextField
							name={name}
							value={value}
							onChange={onChange}
							className={Styles["text-field"]}
							id="filter-name"
							variant="outlined"
							autoComplete="off"
							type="text"
						/>
					)}
				/>
			</div>
			<div className={"col-xs-3"}>
				<InputLabel className={Styles["text-field-label"]}>
					Data de Inicio
				</InputLabel>
				<Controller
					name="startDate"
					control={control}
					defaultValue=""
					rules={{ required: { value: false } }}
					render={({ field: { onChange, name, value } }) => (
						<MuiPickersUtilsProvider utils={MomentUtils}>
							<DatePicker
								value={value}
								onChange={onChange}
												
								disableToolbar
								className={Styles["text-field"]}
								variant="inline"
								inputVariant="outlined"
								format="DD-MM-YYYY"
							/>
						</MuiPickersUtilsProvider>
					)}
				/>
			</div>
			<div className={"col-xs-3"}>
				<InputLabel className={Styles["text-field-label"]}>
					Data de Fim
				</InputLabel>
				<Controller
					name="endDate"
					control={control}
					defaultValue=""
					rules={{ required: { value: false } }}
					render={({ field: { onChange, name, value } }) => (
						<MuiPickersUtilsProvider utils={MomentUtils}>
							<DatePicker
								value={value}
								onChange={onChange}
												
								disableToolbar
								className={Styles["text-field"]}
								variant="inline"
								inputVariant="outlined"
								format="DD-MM-YYYY"
							/>
						</MuiPickersUtilsProvider>
					)}
				/>
			</div>
			{/* <div className={"col-xs-3"}>
				<InputLabel className={Styles["text-field-label"]}>
					Data de Realização
				</InputLabel>
				<Controller
					name="completionDate"
					control={control}
					defaultValue=""
					rules={{ required: { value: false } }}
					render={({ field: { onChange, name, value } }) => (
						<TextField
							name={name}
							value={value}
							onChange={onChange}
							className={Styles["text-field"]}
							id="filter-completionDate"
							variant="outlined"
							autoComplete="off"
							type="date"
						/>
					)}
				/>
			</div> */}
			<div className={"col-xs-3"}>
				<InputLabel className={Styles["text-field-label"]}>
					Metodologia
				</InputLabel>
				<Controller
					name="modalityId"
					control={control}
					defaultValue=""
					rules={{ required: { value: false } }}
					render={({ field: { onChange, name, value } }) => (
						<TextField
							name={name}
							value={value}
							onChange={onChange}
							className={Styles["text-field"]}
							id="filter-modalityId"
							variant="outlined"
							select
							autoComplete="off"
							type="date"
						>
							{CoursesSearchData.modalities.map((row) => (
								<MenuItem
									key={row.id}
									value={row.id}
									className={Styles["options"]}
								>
									{row.name}
								</MenuItem>
							))}
						</TextField>
					)}
				/>
			</div>
			<div className={"col-xs-3"}>
				<InputLabel className={Styles["text-field-label"]}>
					Estado
				</InputLabel>
				<Controller
					name="enrollmentStatusId"
					control={control}
					defaultValue=""
					rules={{ required: { value: false } }}
					render={({ field: { onChange, name, value } }) => (
						<TextField
							name={name}
							value={value}
							onChange={onChange}
							className={Styles["text-field"]}
							id="filter-enrollmentStatusId"
							variant="outlined"
							select
							autoComplete="off"
							type="date"
						>
							{CoursesSearchData.enrollmentStatuses.map((row) => (
								<MenuItem
									key={row.id}
									value={row.id}
									className={Styles["options"]}
								>
									{row.nome}
								</MenuItem>
							))}
						</TextField>
					)}
				/>
			</div>
			{/* <div className={"col-xs-3"}>
				<InputLabel className={Styles["text-field-label"]}>
					Certificado
				</InputLabel>
				<Controller
					name="isCertificateAvailable"
					control={control}
					defaultValue=""
					rules={{ required: { value: false } }}
					render={({ field: { onChange, name, value } }) => (
						<TextField
							name={name}
							value={value}
							onChange={onChange}
							className={Styles["text-field"]}
							id="filter-certificate"
							variant="outlined"
							select
							autoComplete="off"
							type="date"
						>
							<MenuItem
								key="2"
								value="2"
								className={Styles["options"]}
							>
								Em Espera
							</MenuItem>
							<MenuItem
								key="0"
								value="0"
								className={Styles["options"]}
							>
								Rejeitado
							</MenuItem>
							<MenuItem
								key="1"
								value="1"
								className={Styles["options"]}
							>
								Aprovado
							</MenuItem>
							<MenuItem
								key="3"
								value="3"
								className={Styles["options"]}
							>
								Processado
							</MenuItem>
						</TextField>
					)}
				/>
			</div> */}
			{/* <div className={"col-xs-3"}></div> */}
			<div className={"col-xs-3"}></div>
			<div className={"col-xs-3"}>
				<Button
					variant="contained"
					className={Styles["btn-filter"]}
					color="primary"
					disableElevation
					onClick={resetForm}
				>
					Limpar Dados
				</Button>
			</div>
			<div className={"col-xs-3"}>
				<Button
					type="submit"
					variant="contained"
					color="primary"
					className={Styles["btn-search"]}
					disableElevation
				>
					Pesquisar
				</Button>
			</div>
		</form>
	);
};

export default FormCompletedFilter;
